import Image from "next/image";
import { ArrowRight, Search, SearchIcon, X } from "lucide-react";
import { usePathname } from "next/navigation";
import useSafeBack from "@/hooks/useSafeBack";


const MobileSearchButton = ({ onClick, SearchTitle }) => {
    const goBack = useSafeBack();
    const pathname = usePathname();
    const isSingleProduct = pathname.startsWith("/product/");
    const isSearch = pathname === "/search" || pathname.startsWith("/search/");
    const isCategories = pathname === "/category" || pathname.startsWith("/category/");

    return (
        <>
            {isSingleProduct ? (
                <button type="button" aria-label="جستجو" onClick={onClick} className=" w-10 h-10 flex items-center justify-center">
                    <SearchIcon size={24} className="text-jmt-neutral-800" />
                </button>

            ) : isSearch ? (
                <div className="flex items-center justify-between space-x-4">
                    <button type="button" aria-label="بازگشت" className="flex items-center text-jmt-neutral-900"
                        onClick={() => goBack()} >
                        <ArrowRight size={24} />
                    </button>
                    <button
                        onClick={onClick}
                        className="w-full flex items-center justify-between bg-jmt-neutral-100 border border-jmt-neutral-100 rounded-lg leading-6 px-2 py-1.5 lg:px-5 lg:py-3 gap-2 transition-colors cursor-pointer" >
                        {SearchTitle ? (
                            <div className="flex items-center gap-2">
                                <Search size={24} className="text-jmt-neutral-400" />

                                <p className="text-sm text-jmt-neutral-800 font-bold">
                                    {SearchTitle}
                                </p>
                            </div>
                        ) : (
                            <div className="flex items-center gap-2">
                                <Search size={24} className="text-jmt-neutral-400" />

                                <div className="flex items-center gap-1.5">
                                    <span className="text-jmt-neutral-600 text-sm font-bold">
                                        جستجو در
                                    </span>
                                    <div className="w-15 h-4">
                                        <Image
                                            src="/images/logo/logoBlack.png"
                                            unoptimized
                                            alt="لوگو ژومنت"
                                            className="object-contain w-full h-full"
                                            width={150}
                                            height={40}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {SearchTitle && <X size={20} className="text-jmt-neutral-600" />}

                    </button>
                </div>
            ) : isCategories ? (
                <div
                    onClick={onClick}
                    className="w-full flex items-center justify-between border-b border-jmt-neutral-200 px-4 py-3 cursor-pointer"
                >
                    <div className="flex items-center gap-2">
                        <button
                            type="button"
                            aria-label="بازگشت"
                            className="flex items-center text-jmt-neutral-900"
                            onClick={(e) => {
                                e.stopPropagation();
                                goBack();
                            }}
                        >
                            <ArrowRight size={24} />
                        </button>

                        <p className="text-sm text-jmt-main font-bold">
                            {SearchTitle}
                        </p>
                    </div>

                    <Search size={24} className="text-jmt-neutral-800" />
                </div>
            ) : (
                <button
                    onClick={onClick}
                    className="w-full flex items-center bg-jmt-neutral-100 transition-colors rounded-lg px-4 py-2.5 gap-3 cursor-pointer border border-transparent" >

                    <Search
                        size={24}
                        className="text-jmt-neutral-400" />

                    {/* logo & text */}
                    <div className="flex items-center gap-1.5">
                        <span className="text-jmt-neutral-600 text-sm font-bold">
                            جستجو در
                        </span>
                        <div className="w-15 h-4">
                            <Image
                                src="/images/logo/logoBlack.png"
                                unoptimized
                                alt="لوگو ژومنت"
                                className="object-contain w-full h-full"
                                width={150}
                                height={40}
                            />
                        </div>
                    </div>

                </button>
            )
            }

        </>
    );
};

export default MobileSearchButton;
